/**
 * Freeze, unfreeze and block through the concierge (docs/cabinet-redesign/02 §5.1 В-5, owner 31.10): only when the
 * card's provider cannot do it from the app — a real request the manager works in the back office, with its own thread
 * and card. Unfreeze and block are confirmed with step-up like the in-app action (403 STEP_UP_REQUIRED → the chooser,
 * purpose CARD_UNFREEZE / CARD_BLOCK → again with the grant); a freeze needs none.
 */
import { http } from './http';

/** ADD_TO_WALLET — the concierge's «С консьержем» on the Wallet card: the manager adds the card together with the client. */
export type CardActionKind = 'FREEZE' | 'UNFREEZE' | 'BLOCK' | 'ADD_TO_WALLET';
export type CardActionStatus = 'PENDING' | 'DONE' | 'REJECTED';

export interface CardActionView {
  id: string;
  action: CardActionKind;
  status: CardActionStatus;
  cardLastFour: string | null;
  reason: string | null;
  /** The manager's words when rejected — shown to the client. */
  rejectReason: string | null;
  createdAt: string;
  decidedAt: string | null;
  /** The request's thread. */
  ticketId: string | null;
}

const BASE = '/v1/showcase/me/card/action-requests';

export const cardActionsApi = {
  /** 201 — the request (a live one of the same action is returned as is); 409 CARD_ACTION_IN_APP — do it in the app. */
  create(action: CardActionKind, reason: string | null, opts?: { grant?: string }) {
    const config = opts?.grant ? { headers: { 'X-Reveal-Grant': opts.grant } } : undefined;
    return http.post<CardActionView>(BASE, { action, reason }, config).then(r => r.data);
  },
  mine() {
    return http.get<CardActionView[]>(BASE).then(r => r.data);
  },
};

/** The live request of this action, if any — the manage sheet then opens its thread instead of a new request. */
export function pendingOf(list: CardActionView[], action: CardActionKind): CardActionView | null {
  return list.find(r => r.action === action && r.status === 'PENDING') ?? null;
}

/** The step-up purpose of a request, as the in-app action: none for a freeze. */
export function stepUpPurposeOf(action: CardActionKind): 'CARD_UNFREEZE' | 'CARD_BLOCK' | null {
  return action === 'UNFREEZE' ? 'CARD_UNFREEZE' : action === 'BLOCK' ? 'CARD_BLOCK' : null;
}
